<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <v-form ref="form">
                    <v-container py-0>
                        <v-layout wrap>            
                            <template v-if="atributos.length > 0" >
                                <v-flex xs12 lg6 v-for="(atributo, index) in atributos" :key="`atributo-${index}`">
                                    <v-select 
                                        v-if="atributo.listaValores != null && (atributo.listaValores.indicadorMultiplaEscolha == null || atributo.listaValores.indicadorMultiplaEscolha == false)" 
                                        :label="retornarTraducao(atributo.codigoUnico)" 
                                        :no-data-text="retornarSemInformacao(atributo.codigoUnico)" 
                                        :items="listaValores[atributo.codigoUnico]" return-object 
                                        item-value="id" item-text="descricao"
                                        :rules="retornarValidacao(atributo.codigoUnico)" 
                                        v-model="valoresSelecionados[atributo.codigoUnico]"
                                        :readonly="true" ></v-select>

                                    <v-select 
                                        v-else-if="atributo.listaValores != null && atributo.listaValores.indicadorMultiplaEscolha == true" 
                                        :label="retornarTraducao(atributo.codigoUnico)" 
                                        :no-data-text="retornarSemInformacao(atributo.codigoUnico)" 
                                        :items="listaValores[atributo.codigoUnico]" return-object 
                                        item-value="id" item-text="descricao"
                                        :rules="retornarValidacao(atributo.codigoUnico)" 
                                        v-model="valoresSelecionados[atributo.codigoUnico]"
                                        multiple chips :readonly="true" ></v-select>                                        

                                    <v-text-field v-else :readonly="true" 
                                        v-model="valoresSelecionados[atributo.codigoUnico]"
                                        :rules="retornarValidacao(atributo.codigoUnico)"
                                        :label="retornarTraducao(atributo.codigoUnico)"></v-text-field>                                                                               
                                </v-flex>   
                            </template> 

                            <template v-else>
                                <v-flex xs12 md12><strong>{{nenhumAtributoEncontrado}}</strong></v-flex>   
                            </template>                                                        
                        </v-layout>
                    </v-container>         
                </v-form>                  
            </v-flex>            
        </v-layout>         
    </v-container>
</template>

<script>
import FormMixin from '@/mixin/form'
import StepMixin from './mixin'

import ParametrizacaoUtil from '../../utils/parametrizacao'
import OnboardingConstantes from '@/constants/onboarding/parametrizacao'

export default {
    mixins: [ FormMixin, StepMixin ], 
    watch:{
        async value(newValue, oldValue){
            this.setTranslation(newValue);
        }
    },
    data () {
        return { 
            listaValores: { },
            valoresSelecionados: { },
            atributos: [],
            atributosEmUso: [
                "RUT",
                "CPF",
                "DOC.ID.COL",
                "DOC.ID.MEX",
                "DOC.ID.USA",
                "DOC.ID.ARG",
                "DOC.ID.CRI",
                "DOC.ID.PAN",
                "DOC.ID.URY",
                "DOC.ID.PER",
                "DOC.ID.ECU",
                "PRIM.NOME",
                "NOME.MEIO",
                "ULT.NOME",   
                "NEC.POSFIS",
                "PREDIO.CL",
                "PREDIO.CO",
                "PREDIO.MX",
                "PREDIO.US",
                "PREDIO.AR",
                "PREDIO.CR",
                "PREDIO.PA",
                "PREDIO.UR",
                "PREDIO.PE",
                "PREDIO.EC",
                "BLOCO",
                "ANDAR",
                "NUM.POSFIS",
                "SALA.GER",
                "NEC.CEL",
                "NEC.CEL.PE",
                "MODEL.CEL",
                "OPERADOR",
                "SF.APPL.ID",
                "SF.REQ.ID",
                "SF.CAND.ID",
                "SF.TMPL.ID",
                "MOD.CONTR",
                "GER.CON.ID",
                "GER.CON.NM",
                "GER.CON.EM",
                "PADRINHO",
                "EMAIL.PAD",       
                "NEC.EQU.CL",
                "NEC.EQU.CO",
                "NEC.EQU.BR",
                "NEC.EQU.MX",
                "NEC.EQU.US",
                "NEC.EQU.AR",
                "NEC.EQU.CR",
                "NEC.EQU.PA",
                "NEC.EQU.UR",
                "NEC.EQU.PE",
                "NEC.EQU.EC",
                "IP",
                "NEC.EMAIL",
                "NEC.RAM.CL",
                "NEC.RAM.BR",
                "NEC.RAM.CO",
                "NEC.RAM.MX",
                "NEC.RAM.US",
                "NEC.RAM.AR",
                "NEC.RAM.CR",
                "NEC.RAM.PA",
                "NEC.RAM.UR",
                "NEC.RAM.PE",          
                "NEC.RAM.EC"
            ]
        }
    },
    computed: { 
        nenhumAtributoEncontrado(){
            return this.$t("Views.Onboarding.Colaborador.PreCadastro.permissoes-acessos-nao-encontrada");
        },                              
    },
    async created(){
        this.$events.$on("locale-has-changed", this.setLocale);
    },
    beforeDestroy(){
        this.$events.$off("locale-has-changed", this.setLocale);
    },        
    methods:{  
        setLocale(){
            this.setTranslation(this.value);
        },
        async setTranslation(newValue){
            if(newValue != null){
                let atributos = newValue.atributo.filter(
                    a => a.parametrizacao != null && a.parametrizacao.indicadorVisivel && 
                        this.atributosEmUso.filter(uso => uso == a.parametrizacao.parametrizacaoOnboardingAtributo.codigoUnico).length == 0
                ).map(
                    a => {
                        return {
                            listaValores: a.parametrizacao.parametrizacaoOnboardingAtributo.listaValores,
                            codigoUnico: a.parametrizacao.parametrizacaoOnboardingAtributo.codigoUnico
                        }
                    }
                );      
                
                this.listaValores = {};
                this.valoresSelecionados = {};

                this.atributos = [];                
                if(atributos.length > 0){     
                    const loading = this.showLoading();
                    let lista = {};

                    for(let cont = 0; cont < atributos.length; cont++){
                        let atr = ParametrizacaoUtil.getValorAtributo(newValue, atributos[cont].codigoUnico); 
                        if(atributos[cont].listaValores != null){
                            const resultado = await ParametrizacaoUtil.listaValores(atributos[cont].listaValores.id);
                            this.$set(this.listaValores, atributos[cont].codigoUnico, resultado.atributo);
            
                            if(atributos[cont].listaValores.indicadorMultiplaEscolha == true){
                                let multiplosValoresSelecionados = [];
                                let multiplosValores = this.$_.parseInt(atr.valor);
                                                                
                                if(atr != null && multiplosValores > 0){
                                    for(let contAtributo = 0; contAtributo < atributos[cont].listaValores.atributo.length; contAtributo++){
                                        let listaValorAtributo = atributos[cont].listaValores.atributo[contAtributo];
                                        let flag = Math.pow(2, listaValorAtributo.sequencial);

                                        if ((multiplosValores & flag) != 0){
                                            multiplosValoresSelecionados.push(listaValorAtributo);
                                        }                                      
                                    }
                                }
                            
                                lista[atributos[cont].codigoUnico] = multiplosValoresSelecionados;
                            }
                            else{
                                if(atr != null){
                                    lista[atributos[cont].codigoUnico] = atr.valor;
                                }
                                else 
                                    lista[atributos[cont].codigoUnico] = null; 
                            }
                        }  
                        else{
                            if(atr != null){
                                lista[atributos[cont].codigoUnico] = atr.valor;
                            }
                            else 
                                lista[atributos[cont].codigoUnico] = null;                     
                        }                    
                    }   

                    this.$set(this, "atributos", atributos);   
                    this.$set(this, "valoresSelecionados", lista);                                        

                    loading.close();
                } 
            }
        },
        retornarTraducao(codigoUnico){
            return this.$t(`Views.Onboarding.Colaborador.PreCadastro.${codigoUnico.replace(/\./gi, "-")}`);
        },
        retornarSemInformacao(codigoUnico){
            return this.$t(`Views.Onboarding.Colaborador.PreCadastro.${codigoUnico.replace(/\./gi, "-")}-sem-opcoes-para-escolha`);
        },
        retornarValidacao(codigoUnico){
            const self = this;
            return [
                val => {
                    const atributo = self.getValorAtributo(codigoUnico);
                    if(atributo != null){
                        if(self.value.atributo[atributo.index].parametrizacao.indicadorMandatorio == true){
                            if(atributo.valor == null){
                                if(atributo.listaValores){
                                    return this.$t("Views.Onboarding.Colaborador.PreCadastro.combo-pendente-preenchimento");                                
                                }
                                else{
                                    return this.$t("Views.Onboarding.Colaborador.PreCadastro.texto-pendente-preenchimento");                                
                                }
                            }
                        }
                    }

                    return true;
                }
            ];
        }           
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/material-dashboard/variables";

</style>
